import { Category } from 'types/common-types'

import ViewController from '../ViewController'

interface Props {
	category: Category
	view: 'grid' | 'list'
	region: 'ladoe' | 'standard' | 'teks'
}

export default function CategoriesWithProducts({ category, view, region }: Props) {
	const items = category.productsCollection.items

	return (
		<div id={category.slug} className="mb-20 scroll-m-28 lg:scroll-m-20">
			<h4 className="mb-1 text-2xl font-semibold">{category.name}</h4>
			<p className="mb-3 font-light">{category.description}</p>
			<hr className="border-slate-200" />
			<ViewController view={view} items={items} region={region} />
		</div>
	)
}
